import React from 'react';
import {
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Button,
	Zoom
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import logo from './../../assets/images/logos/m-clean.png';
import ShareForm from '../forms/ShareForm';
import UrlForm from '../forms/UrlForm';
import SocialShareBtns from '../buttons/SocialShareBtns';

const useStyles = makeStyles((theme) => ({
    dialog: {
		maxWidth: '40%'
	}
}));

const ShareDialog = (props) => {

	// const classes = useStyles();
    
 	return (
 		<>
	    	<Dialog 
	    		open={props.dialogIsOpen} 
	    		onClose={props.handleDialogClose} 
	    		aria-labelledby="form-dialog-login"
	    		fullWidth 
	    		maxWidth="sm"
            //    classes={{ paperFullWidth: classes.dialog }}
	    		TransitionComponent={Zoom}
	    	>
				<DialogTitle 
					id="form-dialog-login" 
					className="dialog-title"
				>
					<img src={logo} className="mr-1" alt="Mulk.pk" />
					Share Listing
				</DialogTitle>
				<DialogContent>
					<div className="container">
                        <SocialShareBtns
                            url={props.url}
                            listing={props.listing}
                        />
                        <div className="row mt-1 mb-1">
                            <div className="col-md-12 col-sm-12 col-xs-12">
                                <UrlForm
                                    url={props.url} 
                                />
                            </div>
                        </div>
                        <div className="log-separator fl-wrap mt-2 mb-2"><span>or</span></div>
                        <div className="custom-form-new">
                            <ShareForm
                                listing_id={props.listing.id}
                                url={props.url}
                                is_listing={props.isListing}
                            />
                        </div>
			        </div>
				</DialogContent>
		        <DialogActions className="dialog-footer">
		          	<Button onClick={props.handleDialogClose} color="primary">
		            	Cancel
		          	</Button>
		        </DialogActions>
			</Dialog>
		</>
  	)
}

export default ShareDialog;